export default __webpack_public_path__ + "static/media/xpatso.de975cdd.png";